module.exports = __webpack_public_path__ + "static/media/documentation.2b74e238.svg";